import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "eData",
    component: () => import("@/views/eData.vue"),
  },
  {
    path: "/print",
    name: "print",
    component: () => import("@/views/DtcPrint.vue"),
  },
];

const router = new VueRouter({
  routes,
});

export default router;
